import { Button, Card } from '@/components/ui';

interface CustomErrorProps {
  error: Error;
  refetch: () => void;
}

export function CustomError({ error, refetch }: CustomErrorProps) {
  return (
    <div className="flex h-full w-full items-center justify-center p-8">
      <Card className="w-full max-w-md p-8 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <svg className="h-8 w-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h3 className="mb-2 text-lg font-bold text-slate-900">오류가 발생했습니다</h3>
        <p className="mb-6 text-slate-500">
          {error instanceof Error ? error.message : '수강권 목록을 불러오는 데 실패했습니다.'}
        </p>
        <Button onClick={() => refetch()} variant="outline">
          다시 시도
        </Button>
      </Card>
    </div>
  );
}

// export default CustomError;
